import { Box, Stack } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import { antlerStyle } from '@constants/styles';
import { ContentfulTags } from '@enums/ContentfulTags';
import { useMemo, useState } from 'react';
import Filters from './Filters';
import PostGrid from './PostGrid';

const AllPosts = ({ posts }) => {
  const filters = [
    'all',
    ContentfulTags.MEDICARE_101,
    ContentfulTags.DOES_MEDICARE_COVER,
    ContentfulTags.FAIR_SQUARE_UPDATES,
  ];

  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
  const [query, setQuery] = useState('');

  const filteredPosts = useMemo(() => {
    return posts.filter((post) => {
      if (query) return post.title.toLowerCase().includes(query.toLowerCase());
      if (selectedFilter === 'all') return true;
      return post.contentfulTags.includes(selectedFilter);
    });
  }, [query, selectedFilter]);

  return (
    <Box w="100%" px={antlerStyle.px}>
      <Stack spacing={6} pt={8} maxW="1200px" mx="auto">
        <Filters useFilter={[selectedFilter, setSelectedFilter]} useSearch={[query, setQuery]} filters={filters} />
        {filteredPosts.length ? (
          <PostGrid filteredPosts={filteredPosts} />
        ) : (
          <Body1 pt={4} pb={8}>
            No posts matching that search.
          </Body1>
        )}
      </Stack>
    </Box>
  );
};

export default AllPosts;
